/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 29/09/2020  
 */
const loginRequest = () => {
    return {
        username:null,
        password: null ,
        grant_type: 'password',
    }

}

export default loginRequest;